import { Button, Checkbox, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { withStyles } from "@material-ui/styles";
import AdminTitle from "components/admin/smart-visa/AdminTitle";
import AdminTitle2 from "components/admin/smart-visa/AdminTitle2";
import React from "react";
import { useTranslation } from "react-i18next";
const GreenCheckbox = withStyles((theme) => ({
    root: {
        color: theme.palette.success.main,
        '&$checked': {
            color: theme.palette.success.main,
        },
    },
    checked: {},
}))((props) => <Checkbox color="default" {...props} />);

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(a, b, c) {
    return { a, b, c };
}


const useStyles = makeStyles((theme) => ({
    warpListVisa: {
        marginTop: 50
    },
    warpButton: {
        marginTop: 30,
        display: 'flex',
        justifyContent: 'space-between',
    },
    paper: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        padding: theme.spacing(4),
        borderRadius: 16,
    },
    warpForm: {
        marginTop: 30
    },
    warpTabs: {
        marginTop: 30
    },
    table: {
        minWidth: 700,
    },
    tableHead: {
        backgroundColor: '#F1F3F9',
        color: '#8898AA'
    },
    buttonViewDetail: {
        // width: 150,
        backgroundColor: '#00D0FF',
        marginRight: 10
    },
    warpButtonDetail: {
        display: 'flex',
        alignItems: 'center',

    },
    buttonStatusDetail: {

        backgroundColor: 'white',
        padding: 5,
        borderRadius: '50%',
        boxShadow: '0px 0px 2px 2px rgba(23, 43, 77, 0.2)'
    },
    warpData: {
        marginTop: 20
    },
    root: {
        flexGrow: 1,
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    indicator: {
        backgroundColor: '#1094D8',
        color: 'white'
    },
    iconStatus: {
        color: '#2DCE98',
        marginRight: 5
    },
    warpButtonSave: {
        textAlign: 'right',
        marginTop: 30
    },
    buttonSave: {
        marginLeft: 5,
        width: 120
    }
}));



function ConditionPage() {
    const { t, i18n } = useTranslation();



    const rows = [
        createData('BOI', 'Thailand Board of Investment', 'Print'),
        createData('BOI', 'Department Of Employment', 'Print'),
        createData('DOE', 'Digital Economy Promotion Agency', 'Print'),
        createData('DOE', 'National Science and Technology Development Agency', 'Print'),
        createData('DEPA', 'National Innovation Agency ', 'Print'),
    ];



    const classes = useStyles();

    return (
        <Paper className={classes.paper}>
            <AdminTitle title="Setting" subTitle="Condition Config" />


            <div className={classes.warpListVisa} >
                <AdminTitle2 subTitle="Condition" />
            </div>
            <div className={classes.warpData}>
                <TableContainer>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead >
                            <TableRow>
                                <StyledTableCell className={classes.tableHead}>Condition Code</StyledTableCell>
                                <StyledTableCell className={classes.tableHead}>Condition Name</StyledTableCell>
                                <StyledTableCell className={classes.tableHead}>Status</StyledTableCell>
                                <StyledTableCell className={classes.tableHead}> ACTION</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, index) => (
                                <StyledTableRow key={row.name}>
                                    <StyledTableCell component="th" scope="row"> {row.a}</StyledTableCell>
                                    <StyledTableCell >{row.b}</StyledTableCell>
                                    <StyledTableCell >
                                        <div className={classes.warpButtonDetail}>
                                            <FiberManualRecordIcon className={classes.iconStatus} />
                                            <span>Completed</span>
                                            {/* <Button variant="outlined" color="info" size="small" >
                                                Print
                                            </Button> */}
                                        </div>
                                    </StyledTableCell>

                                    <StyledTableCell >
                                        <div className={classes.warpButtonDetail}>
                                            <Button variant="contained" color="primary" size="small" className={classes.buttonViewDetail}>
                                                View
                                            </Button>

                                            <MoreVertIcon className={classes.buttonStatusDetail} />
                                        </div>


                                    </StyledTableCell>

                                </StyledTableRow>
                            ))}

                        </TableBody>
                    </Table>
                </TableContainer>
                <div className={classes.warpButtonSave}>
                    <Button variant="outlined" size="medium" color="primary" className={classes.buttonSave}>
                        Back
                    </Button>

                    <Button variant="contained" size="medium" color="primary" className={classes.buttonSave}>
                        Save
                    </Button>
                </div>
            </div>
        </Paper>
    );
}

export default ConditionPage;
